import styles from "./howItWorksSteps.module.css";
import ansichtkaart1 from "../../shared/assets/ansichtkaart (1).jpg";
import ansichtkaart2 from "../../shared/assets/ansichtkaart (2).jpg";

interface Step {
  id: number;
  title: string;
  description: string;
}

export const HowItWorksSteps = () => {
  const steps: Step[] = [
    {
      id: 1,
      title: "Schrijf",
      description: "Schrijf je verhaal op de ansichtkaart of schrijf een brief",
    },
    {
      id: 2,
      title: "Vul in",
      description: "Vul jouw gegevens in als je post terug wilt ontvangen",
    },
    {
      id: 3,
      title: "Brievenbus",
      description: "Laat je ansichtkaart achter in onze brievenbus, wij doen de rest!",
    },
  ];

  return (
    <section className={styles.howItWorksSteps}>
      <div className={styles.mainContainer}>
        <div className={styles.stepsContainer}>
          {steps.map((step, index) => (
            <div key={step.id} className={styles.stepCard}>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                <p className={styles.stepDescription}>{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className={styles.stepArrow}>
                  <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.2283 0.527264C12.8888 0.189663 12.4283 -7.11441e-09 11.9481 0C11.4679 7.11441e-09 11.0074 0.189663 10.6678 0.527264C10.3283 0.864865 10.1375 1.32275 10.1375 1.80019C10.1375 2.27763 10.3283 2.73552 10.6678 3.07312L14.8185 7.20005H1.81032C1.33019 7.20005 0.869729 7.38969 0.530229 7.72724C0.190729 8.0648 0 8.52262 0 9C0 9.47738 0.190729 9.9352 0.530229 10.2728C0.869729 10.6103 1.33019 10.8 1.81032 10.8H14.8185L10.6678 14.9269C10.3283 15.2645 10.1375 15.7224 10.1375 16.1998C10.1375 16.6773 10.3283 17.1351 10.6678 17.4727C11.0074 17.8103 11.4679 18 11.9481 18C12.4283 18 12.8888 17.8103 13.2283 17.4727L20.4696 10.2729C20.6378 10.1058 20.7711 9.90733 20.8622 9.68892C20.9532 9.47051 21 9.23641 21 9C21 8.76359 20.9532 8.52949 20.8622 8.31108C20.7711 8.09267 20.6378 7.89422 20.4696 7.72707L13.2283 0.527264Z"
                      fill="#5B73CB"
                    />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className={styles.postcardsContainer}>
          <div className={styles.postcardWrapper}>
            <img src={ansichtkaart2} alt="Ansichtkaart voorbeeld 2" className={styles.postcardBack} />
          </div>
          <div className={styles.postcardWrapper}>
            <img src={ansichtkaart1} alt="Ansichtkaart voorbeeld 1" className={styles.postcardFront} />
          </div>
        </div>
      </div>
    </section>
  );
};
